import './CheckoutConfirm.scss';

import React from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import Aside from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/Aside/Aside';
import Content from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/Content/Content';
import Footer from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/Footer/Footer';
import Header from '@/ebat/components/blocks/Scanbat/Common/Header/Header';

import {
  CheckoutConfirmDefaultProps,
  CheckoutConfirmPropTypes,
} from './CheckoutConfirm.proptypes';
import useCheckoutConfirm from './useCheckoutConfirm';

const CheckoutConfirm = ({
  company,
  disabled,
  isLoading,
  order,
  warehouse,
}) => {
  const { onRemoveWarehouse } = useCheckoutConfirm();

  return (
    <div className="wrapper wrapper--full">
      <Header
        className="scanbat-checkout-confirm-page__header"
        company={company}
        disabled={disabled}
        link={ROUTE_SCANBAT}
        onRemoveWarehouse={onRemoveWarehouse}
        warehouse={warehouse}
      />
      <Aside
        className="scanbat-checkout-confirm-page__aside"
        order={order}
        warehouse={warehouse}
      />
      <Content
        className="scanbat-checkout-confirm-page__content"
        disabled={disabled}
        isLoading={isLoading}
        order={order}
      />
      <Footer
        className="scanbat-checkout-confirm-page__footer"
        disabled={disabled}
        isLoading={isLoading}
        onRemoveWarehouse={onRemoveWarehouse}
      />
    </div>
  );
};

CheckoutConfirm.defaultProps = {
  ...CheckoutConfirmDefaultProps,
};

CheckoutConfirm.propTypes = {
  ...CheckoutConfirmPropTypes,
};

export default CheckoutConfirm;
